<div class="gen-table-modal">
	@if (isPagi) {
		<app-gen-table-pagination
			[filterField]="filterField"
			[filterFieldValue]="filterFieldValue"
			[overrideUpperFields]="overrideUpperFields"
			[tableName]="tableName"
			[isCheckItems]="isCheckItems || chooseOnlyOne"
			[preChosenItems]="preChosenItems"
			[filterFieldApiObject]="filterFieldApiObject"
			[filterFieldOrs]="filterFieldOrs"
			(rowValidChange)="rowValidChange($event)"
			(checkedItemsChanged)="checkedItemsChanged($event)"
		/>
	} @else {
		<app-gen-table
			[filterField]="filterField"
			[filterFieldValue]="filterFieldValue"
			[overrideUpperFields]="overrideUpperFields"
			[tableName]="tableName"
			[isCheckItems]="isCheckItems || chooseOnlyOne"
			[preChosenItems]="preChosenItems"
			[filterFieldApiObject]="filterFieldApiObject"
			[filterFieldOrs]="filterFieldOrs"
			(rowValidChange)="rowValidChange($event)"
			(checkedItemsChanged)="checkedItemsChanged($event)"
		/>
	}
</div>

@if (selectedRows.length) {
	<div class="table-display">
		<h4>{{ "chosen_items" | langVal }} :</h4>
		<div class="chosen-items">
			@for (row of selectedRows; track row) {
				<div>{{ row[fieldNameInItemToDisplay || "id"] }}</div>
			}
		</div>
	</div>
}
@if (error && !ignoreError) {
	<p class="error">{{ error | langVal }}</p>
}

<div class="modal-btns">
	<app-btn-ext
		text="exit"
		(clickEv)="onClose.emit()"
	/>

	@if (isCheckItems) {
		<button
			(click)="onClose.emit(selectedRows)"
			[disabled]="!isFormSubmittable"
			class="btn btn-primary"
		>
			{{ "continue_to_email" | langVal }}
		</button>
	}
	@if (chooseOnlyOne) {
		@if (
			selectedRows.length && selectedRows[0]?.contactway_identifier === "phone"
		) {
			<button
				(click)="onClose.emit(selectedRows)"
				[disabled]="!isFormSubmittable"
				class="btn btn-primary"
			>
				{{ "sms" | langVal }}
			</button>
			<button
				(click)="closeWhatsapp()"
				[disabled]="!isFormSubmittable"
				class="btn btn-primary"
			>
				{{ "whatsapp" | langVal }}
			</button>
		} @else {
			<button
				(click)="onClose.emit(selectedRows)"
				[disabled]="!isFormSubmittable"
				class="btn btn-primary"
			>
				{{ "continue" | langVal }}
			</button>
		}
	}
	@if (updateRow) {
		<button
			[disabled]="!editedRow"
			(click)="onClose.emit(editedRow)"
			class="btn btn-default"
		>
			{{ "continue" | langVal }}
		</button>
	}
</div>
